<template>
  <header class="page-header">
    <h1>{{ pageTitle }}</h1>
  </header>

  <BlockLoading v-if="isLoadingIcApplicationsConfig" class="p-2" />

  <BlockError v-else-if="hasErrorLoadingIcApplicationsConfig" can-retry @retry="refetchIcApplicationsConfig">
    <h2 class="h5">Error loading grid configuration</h2>
    {{ errorLoadingIcApplicationsConfig?.message }}
  </BlockError>

  <GuDatagridServer
    v-else
    :grid-options="gridConfig"
    :api-options="API_OPTIONS"
    :enable-export-button="enableExportButton"
    :enable-quick-filter="enableQuickFilter"
    :filter-toggle-options="filterToggleOptions"
    queue-name="order_details"
  />
</template>

<script setup>
import { ref, watch } from 'vue'

import { GuDatagridServer } from '@gu-datagrid'
import { getSiteConfig } from '@shared/api/systemData.api'
import BlockError from '@shared/components/BlockError.vue'
import BlockLoading from '@shared/components/BlockLoading.vue'

import { PROJECTS_API } from '@projects/api/projects.api'
import { buildGridConfig } from '@projects/config/projects.queue.datagrid.config'

const PROJECTS_QUEUE_CONFIG = 'projects.orders.datagrid.config.json'

const {
  data: icApplicationsConfig,
  error: errorLoadingIcApplicationsConfig,
  isError: hasErrorLoadingIcApplicationsConfig,
  isPending: isLoadingIcApplicationsConfig,
  refetch: refetchIcApplicationsConfig,
} = getSiteConfig(PROJECTS_QUEUE_CONFIG)

const API_OPTIONS = {
  rowsUrl: PROJECTS_API.GET_ORDERS,
  fileExportUrl: PROJECTS_API.EXPORT_ORDERS,
  defaultExportFilename: 'Orders Export',
}

const gridConfig = ref()
const enableExportButton = ref()
const enableQuickFilter = ref()
const filterToggleOptions = ref()
const pageTitle = ref()

watch(icApplicationsConfig, (applicationsConfig) => {
  if (!applicationsConfig) return

  gridConfig.value = buildGridConfig(applicationsConfig) // TODO: need to pass pageVars here
  enableExportButton.value = applicationsConfig?.enableExportButton
  enableQuickFilter.value = applicationsConfig?.enableQuickFilter
  filterToggleOptions.value = applicationsConfig?.filterToggleOptions
  pageTitle.value = applicationsConfig?.windowTitle || 'My Orders'
})
</script>
